<template>
    <div
        class="relative flex h-full w-full min-w-[120px] flex-col rounded border border-gray-325"
    >
        <div
            class="whitespace-nowrap px-3 pr-3 pt-3 text-[12px] font-semibold tracking-tight text-gray-625 md:text-[14px]"
        >
            <span v-html="title"></span>
        </div>
        <div
            v-if="value !== ''"
            class="px-3 pb-2 text-[20px] font-semibold tracking-tight md:text-[27px] lg:text-[34px]"
        >
            {{ value ?? 0 }}
        </div>
        <slot />
        <div
            v-if="reason"
            class="mt-auto border-t border-gray-325 bg-gray-125 px-3 py-2 text-[12px] font-medium text-gray-725 md:text-[14px]"
        >
            <text-clamp autoResize :max-lines="1" :text="reason"></text-clamp>
        </div>

        <new-modal v-if="helpText" :show-header="false" :show-title="false">
            <template #trigger>
                <div
                    class="absolute right-3 top-3 text-gray-425 hover:cursor-pointer hover:text-gray-625"
                >
                    <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clip-path="url(#clip0_1327_30872)">
                            <path
                                d="M11 20.1654C16.0626 20.1654 20.1666 16.0613 20.1666 10.9987C20.1666 5.93609 16.0626 1.83203 11 1.83203C5.93737 1.83203 1.83331 5.93609 1.83331 10.9987C1.83331 16.0613 5.93737 20.1654 11 20.1654Z"
                                stroke="currentColor"
                                stroke-width="1.83333"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M8.33252 8.2515C8.54803 7.63886 8.97341 7.12226 9.53331 6.7932C10.0932 6.46414 10.7515 6.34386 11.3916 6.45365C12.0317 6.56344 12.6123 6.89623 13.0305 7.39307C13.4487 7.8899 13.6777 8.51873 13.6767 9.16817C13.6767 11.0015 10.9267 11.9182 10.9267 11.9182"
                                stroke="currentColor"
                                stroke-width="1.83333"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M11 15.582H11.0088"
                                stroke="currentColor"
                                stroke-width="1.83333"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_1327_30872">
                                <rect width="22" height="22" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </template>
            <template #content>
                <div class="text-center">
                    {{ helpText }}
                </div>
            </template>
        </new-modal>
    </div>
</template>
<script>
import Tooltip from "@/Components/Tooltip.vue";
import NewModal from "@/Components/NewModal.vue";

export default {
    name: "StudentDashboardWidget",
    components: { NewModal, Tooltip },
    props: {
        title: {
            type: String,
            default: "",
        },
        value: {
            type: [String, Number],
            default: "",
        },
        reason: {
            type: String,
            default: "",
        },
        helpText: {
            type: String,
            default: "",
        },
        showHelpText: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
